import { Component } from '@angular/core';
import { SkipUserComponentFeedbackEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'User Component Feedbacks') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-skipusercomponentfeedback-form',
    templateUrl: './skipusercomponentfeedback.form.component.html'
})
export class SkipUserComponentFeedbackFormComponent extends BaseFormComponent {
    public record!: SkipUserComponentFeedbackEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

